// NÃO USE PARA VALIDAÇÕES DE DADOS SENSÍVEIS, qualquer um pode editar esses valores no localStorage.
// use para decidir o que mostrar ao usuário.

const getFromLocalStorage = (cKey, defaultValue) => {
  const value = localStorage.getItem(cKey);
  if (value == null) return defaultValue;
    return JSON.parse(value);
};

export const clearPermissions = () => {
  localStorage.removeItem('aPermissions');
  localStorage.removeItem('bCanEditPerms');
}

export const hasFullAccess = () => {
  return getFromLocalStorage('bCanEditPerms', false);
};

const getUserPermissions = () => {
  return getFromLocalStorage('aPermissions', []);
};

const hasPermission = (cPerm) => {
  return getUserPermissions().includes(cPerm);
}

export const can = (...aPerms) => {
  if (hasFullAccess()) return true;
  return aPerms.every(hasPermission);
};

export const canAtLeast = (...aPerms) => {
  if (hasFullAccess()) return true;
  return aPerms.some(hasPermission);
};
